var map = {
	"./sinon": 300,
	"./sinon.js": 300,
	"./sinon/assert": 303,
	"./sinon/assert.js": 303,
	"./sinon/behavior": 305,
	"./sinon/behavior.js": 305,
	"./sinon/call": 306,
	"./sinon/call.js": 306,
	"./sinon/collection": 307,
	"./sinon/collection.js": 307,
	"./sinon/extend": 308,
	"./sinon/extend.js": 308,
	"./sinon/format": 309,
	"./sinon/format.js": 309,
	"./sinon/log_error": 312,
	"./sinon/log_error.js": 312,
	"./sinon/match": 313,
	"./sinon/match.js": 313,
	"./sinon/mock": 314,
	"./sinon/mock.js": 314,
	"./sinon/sandbox": 315,
	"./sinon/sandbox.js": 315,
	"./sinon/spy": 316,
	"./sinon/spy.js": 316,
	"./sinon/stub": 317,
	"./sinon/stub.js": 317,
	"./sinon/test": 318,
	"./sinon/test.js": 318,
	"./sinon/test_case": 319,
	"./sinon/test_case.js": 319,
	"./sinon/times_in_words": 320,
	"./sinon/times_in_words.js": 320,
	"./sinon/typeOf": 321,
	"./sinon/typeOf.js": 321,
	"./sinon/util/core": 322,
	"./sinon/util/core.js": 322,
	"./sinon/util/event": 324,
	"./sinon/util/event.js": 324,
	"./sinon/util/fake_server": 325,
	"./sinon/util/fake_server.js": 325,
	"./sinon/util/fake_server_with_clock": 326,
	"./sinon/util/fake_server_with_clock.js": 326,
	"./sinon/util/fake_timers": 327,
	"./sinon/util/fake_timers.js": 327,
	"./sinon/util/fake_xdomain_request": 329,
	"./sinon/util/fake_xdomain_request.js": 329,
	"./sinon/util/fake_xml_http_request": 330,
	"./sinon/util/fake_xml_http_request.js": 330,
	"./sinon/util/timers_ie": 331,
	"./sinon/util/timers_ie.js": 331,
	"./sinon/util/xdr_ie": 332,
	"./sinon/util/xdr_ie.js": 332,
	"./sinon/util/xhr_ie": 333,
	"./sinon/util/xhr_ie.js": 333,
	"./sinon/walk": 334,
	"./sinon/walk.js": 334
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 302;



//////////////////
// WEBPACK FOOTER
// ./~/sinon/lib ^\.\/.*$
// module id = 302
// module chunks = 1